import * as ErrorLogConstants from './ErrorLogConstants'
export const setActiveErrorItem = (data ,index)=> {
    return {
        type: ErrorLogConstants.SET_ACTIVE_ERROR,
        data: data,
        index:index
    };
};